import { render, staticRenderFns } from "./VisualizarOrganogramaDialog.vue?vue&type=template&id=6bf758af"
import script from "./VisualizarOrganogramaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarOrganogramaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports